(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-pill-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // URL settings may be absolute links; compare paths just as menu link.current
    // does, ignoring query strings and a trailing slash.
    function syncPillMenus() {
      const normalizePath = path => path.replace(/\/+$/, '') || '/';
      const currentPath = normalizePath(window.location.pathname);
      document.querySelectorAll('[data-sw-pill-menu]').forEach(menu => {
        menu.querySelectorAll('a[href]').forEach(link => {
          const destination = new URL(link.getAttribute('href'), window.location.href);
          const isCurrent = destination.origin === window.location.origin &&
            normalizePath(destination.pathname) === currentPath;
          link.classList.toggle('active', isCurrent);
          if (isCurrent) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        // Keep the selected collection visible in the horizontally scrolling row,
        // including when Shopify reloads the section in the theme editor.
        const active = menu.querySelector('a.active');
        if (active && window.innerWidth < 768) {
          const relativeLeft = active.getBoundingClientRect().left -
            menu.getBoundingClientRect().left + menu.scrollLeft;
          menu.scrollLeft = relativeLeft - (window.innerWidth / 2 - 40);
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncPillMenus);
    } else {
      syncPillMenus();
    }
    document.addEventListener('shopify:section:load', syncPillMenus);
    window.addEventListener('pageshow', syncPillMenus);
  })();

  } catch(e) { console.error(e); }
})();
})();
